import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';

import {
  CreateInternalAssessmentRequest,
  MortgageAssessmentDetail,
  RelodgeAssessmentArgs,
} from '../types/internal-assessment';

export const assessmentApi = createApi({
  reducerPath: 'assessmentApi',
  baseQuery: customBaseQuery,
  tagTypes: ['Assessment'],
  endpoints: (builder) => ({
    // POST /assessments/internal — creates an internal assessment.
    // brokerId is omitted by callers; the server defaults to the logged-in user.
    createInternalAssessment: builder.mutation<
      MortgageAssessmentDetail, // unwrapped from the ApiResponse envelope below
      CreateInternalAssessmentRequest
    >({
      query: (body) => ({
        url: '/assessments/internal',
        method: 'POST',
        body,
      }),
      transformResponse: (response: ApiResponse<MortgageAssessmentDetail>) =>
        response.data,
      invalidatesTags: ['Assessment'],
    }),

    // POST /assessments/internal/:previousAssessmentId/relodge — creates a fresh
    // assessment cloned from a previous one (applicants, questionnaire and
    // linked properties carry over; integrations/status start clean). The body
    // is optional; omit it to mirror the previous assessment entirely.
    relodgeAssessment: builder.mutation<
      MortgageAssessmentDetail, // unwrapped from the ApiResponse envelope below
      RelodgeAssessmentArgs
    >({
      query: ({ previousAssessmentId, body }) => ({
        url: `/assessments/internal/${previousAssessmentId}/relodge`,
        method: 'POST',
        body: body ?? {},
      }),
      transformResponse: (response: ApiResponse<MortgageAssessmentDetail>) =>
        response.data,
      invalidatesTags: ['Assessment'],
    }),
  }),
});

export const {
  useCreateInternalAssessmentMutation,
  useRelodgeAssessmentMutation,
} = assessmentApi;
